import {createReducer, on} from '@ngrx/store';
import {loginUserSuccessful, loginUser, loginUserFailed} from './auth.actions';

export interface AuthState {
  // authUser : AuthUser | null
  isLoggedIn: boolean;
  loginLoading: boolean;

}

export const initialState: AuthState = {
  // authUser : null,
  isLoggedIn: false,
  loginLoading: false,

}

export const authReducer = createReducer(
  initialState,

  on(loginUser, (state) => ({
    ...state, loginLoading: true
  })),

  on(loginUserSuccessful, (state) => ({
    ...state, loginLoading: false, isLoggedIn: true
  })),

  on(loginUserFailed , (state) => ({
    ...state, loginLoading: false
  })),


);
